<!-- 推荐信息 -->
<template>
<div class="info-block">
  <router-link :to="{path: '#'}" class="info-block-a">
    <div class="title"><span>最热|</span>{{info.title.length>titleLength?news.title.substring(0,titleLength)+'...':info.title}}</div>
    <div class="label">{{info.create_time}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'TjInfo',
  props: {
    titleLength: {
      type:String,
      default:'20'
    },
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  //border:0px solid #fff;
  border-bottom:1px solid #eee;
  height:50px;
  padding:5px 5px 5px 5px;
  margin:0px 0px 10px 0px;
  //background-color:green;
}

.info-block .info-block-a:hover{
  border-bottom:1px solid var(--color6);
  //box-shadow:0px 0px 1px 0px var(--color6);
}

.info-block .info-block-a:hover > .title{
  color: var(--color6);
  //box-shadow:0px 0px 1px 0px var(--color6);
}

.info-block-a .title{
  position:relative;
  width: 100%;
  height:30px;
  color:#000;
  font-size:12px;
  font-weight:400;
  line-height:20px;
  text-align:left;
}

.info-block-a .title span{
  font-size:12px;
  color:var(--color6);
  letter-spacing:3px;
}

.info-block-a .label{
  position:relative;
  width: 100%;
  padding-right:10px;
  font-size:12px;
  color:#888888;
  line-height:20px;
  text-align:left;
}
</style>



// WEBPACK FOOTER //
// src/components/module/TjInfo1.vue